<template>
  <div class="dialogEnv">
    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled">
      <env-form :formItem="env"></env-form>
    </el-form>
  </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/dataProcess'
  import envForm from '../assets/components/form'
  export default {
    name: "dialogEnv",
    components:{
      envForm
    },
    data() {
      return {
        disabled:true,
        envData:{},
        env:[]
      }
    },
    methods:{
      /*数据渲染*/
      dataRender(){
        for(let i = 0;i < this.env.length;i++){
          for (let key of Object.keys(this.envData)) {
            if(key === this.env[i].name){
              this.env[i].value = this.envData[key];
            }
          }
        }
      }
    },
    created(){
      this.env = arrayData.data2.env;
      /*是否可以修改*/
      bus.$on("change",()=>{
        this.disabled=false;
      });
      /*接收数据*/
      bus.$on("env",msg=>{
        this.envData = msg;
        this.dataRender();
      });
      /*接收案例编号*/
      bus.$on("caseNumber",msg=>{
        this.env[0].value = msg;
      })
    }
  }
</script>

<style scoped>
  .dialogEnv{
    width: 99%;
    height: 100%;
  }
  .formMsg{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }

</style>



// WEBPACK FOOTER //
// src/exportData/dialogEnv.vue